module.exports = __webpack_public_path__ + "img/221122-bimistock-image-14@1x.a9a3b224.png";